import {
  divider2,
  divider3,
  earnedimg,
  msummaryimg,
  nftimg1,
  summaryimg,
} from "assets";
import { MainContainer } from "components/common";
import React from "react";
import { Image } from "react-bootstrap";
import { MainDiv, MainDivContent, TopMainDiv } from "./elements";
import AvailabletoStake from "./availabletoStake";
import Mystaking from "./mystaking";
import Faq from "./faq";

const MainSectionComp = ({
  userReward,
  staked,
  userIds,
  stakedDetail,
  getUserNfts,
  getClaimedReward,
  getUserStaked,
}) => {
  return (
    <div>
      <MainContainer fluid>
        <TopMainDiv>
          <MainDiv>
            <Image src={summaryimg} className="summarimg" />

            <MainDivContent>
              <div className="first-div">
                <Image src={nftimg1} />
                <div className="content-text">
                  <h1>STAKING</h1>
                  <h2>{staked}</h2>
                  <p>total NFTs</p>
                </div>
              </div>
              <div className="divider-img">
                <Image src={divider3} fluid />
              </div>

              <div className="mdivider-img">
                <Image src={divider2} fluid />
              </div>

              <div className="first-div">
                <Image src={earnedimg} />
                <div className="content-text">
                  <h1>EARNED</h1>
                  <h2>{userReward ? userReward : "--"}</h2>
                  <p>total Voxel Energy</p>
                </div>
              </div>
            </MainDivContent>
          </MainDiv>
        </TopMainDiv>
      </MainContainer>
      <AvailabletoStake userIds={userIds} />
      <Mystaking
        stakedDetail={stakedDetail}
        getUserNfts={getUserNfts}
        getClaimedReward={getClaimedReward}
        getUserStaked={getUserStaked}
      />
      <Faq />
    </div>
  );
};

export default MainSectionComp;
